import { logger } from "@/infrastructure/services/LoggerService";
import api from "@/plugins/api";
export class PermissionsService {
    async getPermissions() {
        try {
            const response = await api.get("/schema/permissions", {
                unwrapEnvelope: true,
            });
            return response.data;
        }
        catch (error) {
            logger.debug("Failed to get permissions:", error);
            throw error;
        }
    }
}
